export default "__VITE_ASSET__dbbe8563__"